import getProfitLimits from "./getProfitLimits";
import putProfitLimits from "./putProfitLimits";

export default { getProfitLimits, putProfitLimits };
